import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  MenuItem,
  Paper,
  TextField,
  Autocomplete
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { MAIN_URL } from "../../../Configurations/Urls";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import toast from "react-hot-toast";
import Header from "../../DataLayouts/Header";


function ProjectSubCategoryForm() {

  const navigate = useNavigate();
  const { id } = useParams(); // if id is present => edit mode
  const mode = id ? "edit" : "add";

  const { userData } = useAuthStore();

  console.log("full uer data is : ", userData);

  const org = userData?.organization;

  const fetchProjectSubCategories = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const res = await axios.get(`${MAIN_URL}/api/project-management/project-sub-categories/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const data = res.data?.data;

      if (data) {
        setFormData({
          organization_id: data.organization_id || "",
          organization_entity_id: data.organization_entity_id || "",
          organization_project_category_id: data.organization_project_category_id || "",
          project_subcategory_name: data.project_subcategory_name || "",
          project_subcategory_short_name: data.project_subcategory_short_name || "",
          description: data.description || ""
        });
      }
    } catch (error) {
      toast.error("Failed to fetch project sub Category data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (mode === "edit" && id) {
      fetchProjectSubCategories();
    }
  }, [mode, id]);

  const [formData, setFormData] = useState({
    organization_id: org?.organization_id || "",
    organization_entity_id: "",
    organization_project_category_id: "",
    project_subcategory_name: "",
    project_subcategory_short_name: "",
    description: ""
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  const validateForm = () => {

    const errors = {};

    if (!formData.organization_project_category_id) errors.organization_project_category_id = "Project Category is required";
    if (!formData.project_subcategory_name) errors.project_subcategory_name = "Project Category Sub Name is required";
    if (formData.project_subcategory_name.length > 150) errors.project_subcategory_name = "Max 150 characters allowed";
    if (formData.project_subcategory_short_name && formData.project_subcategory_short_name.length > 20)
      errors.project_subcategory_short_name = "Max 20 characters allowed";

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };


  // Submit form
  const handleSubmit = async () => {
    setFormErrors({});

    if (!validateForm()) {
      toast.error("Please fix the validation errors.");
      return;
    }

    let organization_entity_id = userData?.organization?.
      entities?.organization_entity_id || null;

    setBtnLoading(true);
    try {
      const token = localStorage.getItem("token");


      if (mode === "edit") {
        await axios.put(`${MAIN_URL}/api/project-management/project-sub-categories/${id}`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Sub Categories updated");
      } else {
        await axios.post(`${MAIN_URL}/api/project-management/project-sub-categories`, { ...formData, organization_entity_id }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        toast.success("Project Sub Categories added");
      }

      navigate("/project-sub-category");
    } catch (err) {
      if (err.response?.status === 422) {
        setFormErrors(err.response.data.errors);
      } else {
        toast.error("Operation failed");
      }
    }
    setBtnLoading(false);
  };


  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };



  const [selectOptions, setSelectOptions] = useState({
    Categories: []
  })

  const fetchProjectCategories = async () => {
    try {
      const response = await axios.get(`${MAIN_URL}/api/project-management/project-categories`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
        params: {
          per_page: "all",
          organization_id: org?.organization_id,
        },
      });

      console.log("response Categories is : ", response);

      setSelectOptions((prev) => ({ ...prev, Categories: response.data.data }));
    } catch (e) {
      console.error("Failed to load Categories");
    }
  };

  useEffect(() => {
    fetchProjectCategories();
  }, []);


  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Project Sub Categories"}
        addMessage={"Project Sub Categories"}
        homeLink={"/project-sub-category"}
        homeText={"Project Sub Categories"}
      />

      {loading ? (
        <Box display="flex" justifyContent="center" py={4}>
          <CircularProgress />
        </Box>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>

         

<Autocomplete
  fullWidth
  options={selectOptions.Categories || []}
  getOptionLabel={(option) => option.project_category_name || ""}
  isOptionEqualToValue={(option, value) =>
    option.organization_project_category_id ===
    value.organization_project_category_id
  }
  value={
    selectOptions.Categories?.find(
      (cat) =>
        cat.organization_project_category_id ===
        formData.organization_project_category_id
    ) || null
  }
  onChange={(event, newValue) => {
    setFormData((prev) => ({
      ...prev,
      organization_project_category_id:
        newValue?.organization_project_category_id || "",
      // optional: reset sub category when category changes
      organization_project_subcategory_id: "",
    }));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Project Category *"
      error={!!formErrors.organization_project_category_id}
      helperText={formErrors.organization_project_category_id}
    />
  )}
/>


                <TextField
                  fullWidth
                  name="project_subcategory_name"
                  label="Project Sub Category Name *"
                  value={formData.project_subcategory_name}
                  onChange={handleChange}
                  error={!!formErrors.project_subcategory_name}
                  helperText={formErrors.project_subcategory_name}
                />

                <TextField
                  fullWidth
                  name="project_subcategory_short_name"
                  label="Project Sub Category Short Name "
                  value={formData.project_subcategory_short_name}
                  onChange={handleChange}
                  error={!!formErrors.project_subcategory_short_name}
                  helperText={formErrors.project_subcategory_short_name}
                />

                <TextField
                  fullWidth
                  multiline
                  minRows={3}
                  label="Description "
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  error={!!formErrors.description}
                  helperText={formErrors.description}
                />

              </Grid>
              <Button
                variant="contained"
                color="primary"
                size="medium"
                onClick={handleSubmit}
                disabled={loading || btnLoading}
                sx={{
                  borderRadius: 2,
                  minWidth: 120,
                  textTransform: "capitalize",
                  fontWeight: 500,
                  mt: 2
                }}
              >
                {loading || btnLoading ? (
                  <CircularProgress size={22} sx={{ color: "#fff" }} />
                ) : mode === "edit" ? (
                  "Update"
                ) : (
                  "Submit"
                )}
              </Button>

            </Paper>
          </Grid>
        </Grid>
      )}

    </Box>
  )
}

export default ProjectSubCategoryForm